import React, { useState } from 'react';
import { INTERESTS } from '../utils/moderation';

const UsernameSetup = ({ suggestedName, onRegister }) => {
  const [username, setUsername] = useState(suggestedName || '');
  const [selectedInterests, setSelectedInterests] = useState([]);
  const [bio, setBio] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const toggleInterest = (interest) => {
    setSelectedInterests(prev =>
      prev.includes(interest) ? prev.filter(i => i !== interest) : [...prev, interest]
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim()) return setError('Username is required');
    if (username.length < 3) return setError('Username must be at least 3 characters');
    if (!/^[a-zA-Z0-9_]+$/.test(username)) return setError('Only letters, numbers and underscores allowed');

    setLoading(true);
    setError('');
    const result = await onRegister(username.trim(), selectedInterests, bio);
    if (result?.error) setError(result.error);
    setLoading(false);
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1000, backdropFilter: 'blur(4px)'
    }}>
      <div className="card" style={{ maxWidth: 480, width: '90%', animation: 'dropIn 0.25s ease' }}>
        <h3 style={{ marginBottom: 6 }}>Join the Community 🌿</h3>
        <p style={{ marginBottom: 24, fontSize: '0.9rem' }}>
          Set your display name and tell us what you're interested in.
        </p>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div>
            <label style={{ fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: 6 }}>
              Display Name
            </label>
            <input
              value={username}
              onChange={e => { setUsername(e.target.value); setError(''); }}
              placeholder="e.g. mindful_soul, hopeful123"
              maxLength={30}
              style={{ background: 'var(--input-bg)', color: 'var(--text-color)' }}
            />
            <p style={{ fontSize: '0.78rem', color: 'var(--text-muted)', marginTop: 4 }}>
              This is what others will see. {username.length}/30
            </p>
          </div>

          <div>
            <label style={{ fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: 8 }}>
              Your Interests (pick up to 5)
            </label>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              {INTERESTS.map(interest => (
                <button
                  key={interest}
                  type="button"
                  onClick={() => toggleInterest(interest)}
                  disabled={!selectedInterests.includes(interest) && selectedInterests.length >= 5}
                  style={{
                    padding: '6px 14px', borderRadius: 'var(--radius-full)',
                    border: selectedInterests.includes(interest) ? '1.5px solid var(--primary-color)' : '1.5px solid var(--border-color)',
                    background: selectedInterests.includes(interest) ? 'var(--primary-light)' : 'var(--card-bg-color)',
                    color: selectedInterests.includes(interest) ? 'var(--primary-color)' : 'var(--text-secondary-color)',
                    fontSize: '0.82rem', fontWeight: 500, cursor: 'pointer',
                    transition: 'all 0.15s ease',
                    opacity: (!selectedInterests.includes(interest) && selectedInterests.length >= 5) ? 0.4 : 1
                  }}
                >
                  {interest}
                </button>
              ))}
            </div>
          </div>

          <div>
            <label style={{ fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: 6 }}>
              Short Bio (optional)
            </label>
            <textarea
              value={bio}
              onChange={e => setBio(e.target.value)}
              placeholder="A little about yourself..."
              maxLength={120}
              rows={2}
              style={{ background: 'var(--input-bg)', color: 'var(--text-color)', resize: 'none' }}
            />
          </div>

          {error && (
            <p style={{ color: '#dc2626', fontSize: '0.875rem', padding: '8px 12px', background: '#fff1f0', borderRadius: 'var(--radius-sm)', border: '1px solid #fca5a5' }}>
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={loading || !username.trim()}
            className="btn primary-btn"
            style={{ alignSelf: 'flex-start', opacity: loading ? 0.7 : 1 }}
          >
            {loading ? 'Setting up...' : 'Enter the Community →'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default UsernameSetup;